import { render } from "./Route.vue?vue&type=template&id=1986f4cb"
import script from "./Route.vue?vue&type=script&lang=js"
export * from "./Route.vue?vue&type=script&lang=js"
script.render = render

export default script